
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 5.563a.52.52 0 00-.52.52v8.06l-3.24-3.256a.52.52 0 00-.735.736l4.128 4.129c.025.023.05.045.079.065h.02l.068.036h.031a.289.289 0 00.068.018.43.43 0 00.101 0c.035.004.07.004.104 0a.299.299 0 00.065-.018h.031l.068-.036h.02l.081-.065 4.127-4.129a.52.52 0 00-.736-.736l-3.24 3.242V6.084a.52.52 0 00-.52-.52h0zM8.871 19.259h8.258a.52.52 0 000-1.04H8.87a.52.52 0 100 1.04z","stroke":"#000"}})])
          )
        }
      }
    